import { progressAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(progressAnatomy.keys);

const baseStyle = definePartsStyle({

});

const modalProgress = definePartsStyle({
  track: {
    bg: 'darkPrimaryButtonHoverColor',
    borderRadius: 'lg',
    h: '10px',
  },
  filledTrack: {
    bg: 'orange.500',
  },
});

export default defineMultiStyleConfig({
  baseStyle,
  variants: {
    modalProgress,
  },
});
